import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getShouldRenderLinksToVarsome } from "../../../state/selectors/general.selectors";

const ConditionalLink = ({ href, shouldRenderLinksToVarsome, text, color }) => {
  return shouldRenderLinksToVarsome ? (
    <a href={href} target="_blank">
      {text}
    </a>
  ) : (
    <span style={{ color: color || "unset" }}>{text}</span>
  );
};

ConditionalLink.propTypes = {
  href: PropTypes.string.isRequired,
  shouldRenderLinksToVarsome: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  color: PropTypes.string,
};
ConditionalLink.defaultProps = {
  color: "",
};

const mapStateToProps = () => ({
  shouldRenderLinksToVarsome: getShouldRenderLinksToVarsome(),
});

export default connect(mapStateToProps)(ConditionalLink);
